import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  version,
} from "react";
import ReactSlider from "react-slider";
import { CiTimer } from "react-icons/ci";
import "../pages/player-slider/Player-slider.css";

const Slider = ({ eventType, delayValue, delayStream, isLoading }) => {
  const sliderRef = useRef(null);
  const labelRef = useRef(null);

  const updateLabelPosition = useCallback(() => {
    const slider = sliderRef.current;
    const label = labelRef.current;
    if (slider && label) {
      const min = parseFloat(slider.min);
      const max = parseFloat(slider.max);
      const percent = (delayValue - min) / (max - min);

      const sliderWidth = slider.offsetWidth;
      const thumbWidth = 16; // approximate default thumb width
      const offset = percent * (sliderWidth - thumbWidth) + thumbWidth / 2;

      label.style.left = `${offset}px`;
    }
  }, [delayValue]);

  useEffect(() => {
    updateLabelPosition();
  }, [delayValue, updateLabelPosition]);

  return (
    <div>
      <div className="slider-wrapper">
        <p className="slider-title">Set Delay</p>

        <div className="slider-container">
          <button
            className="vertical-icon-text"
            // onTouchStart={() => delayValue != 0 && delayStream(delayValue - 1)}
            {...(eventType === "touch"
              ? {
                  onTouchStart: () =>
                    delayValue != 0 && delayStream(delayValue - 1),
                }
              : {
                  onClick: () => delayValue != 0 && delayStream(delayValue - 1),
                })}
            disabled={delayValue == 0 || isLoading}
          >
            <CiTimer size={20} />
            <span>-1s</span>
          </button>
          <div style={{ position: "relative", width: "100%" }}>
            <input
              ref={sliderRef}
              type="range"
              min="0"
              max="30"
              value={delayValue}
              onChange={(e) => delayStream(Number(e.target.value))}
              style={{ width: "100%", accentColor: "black" }}
            />
            <div
              ref={labelRef}
              style={{
                position: "absolute",
                top: "0px",
                transform: "translateX(-50%)",
                background: "#333",
                color: "white",
                width: "20px", // fixed width for consistent shape
                height: "20px",
                lineHeight: "20px",
                textAlign: "center",
                borderRadius: "50%", // always circle
                fontSize: "8px",
                fontFamily: "monospace",
                pointerEvents: "none",
                fontWeight: "bold",
              }}
            >
              {delayValue}
            </div>
          </div>
          {/* 
            <ReactSlider
              min={0}
              max={30}
              disabled={isLoading}
              // step={5}
              // marks={[1, 2, 3, 4, 5]}
              className="horizontal-slider"
              thumbClassName="example-thumb"
              trackClassName="example-track"
              thumbActiveClassName="active-thumb"
              value={Number(delayValue)}
              defaultValue={Number(delayValue)}
              renderThumb={(props, state) => {
                const { key, ...restProps } = props; // Extract 'key' separately
                return (
                  <div key={key} {...restProps}>
                    {state.valueNow}
                  </div>
                );
              }}
              onAfterChange={(val) => {
                console.log("slide val", val);
                delayStream(val);
              }}
            />
           */}
          <button
            className="vertical-icon-text"
            {...(eventType === "touch"
              ? {
                  onTouchStart: () =>
                    delayValue != 30 && delayStream(delayValue + 1),
                }
              : {
                  onClick: () =>
                    delayValue != 30 && delayStream(delayValue + 1),
                })}
            disabled={delayValue == 30 || isLoading}
          >
            <CiTimer size={20} />
            <span>+1s</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Slider;
